<template>
  <div class="breadcrumbs" v-if="showBreadcrumbs">
    <template v-for="breadcrumb in breadcrumbs" :key="breadcrumb.url">
      <span class="breadcrumb" v-if="breadcrumb.name">
        <router-link
          v-if="
            typeof breadcrumb.access === 'undefined' ||
            breadcrumb.access.includes($store.state.auth.jwt?.CustomUserInfo?.Role)
          "
          :to="breadcrumb.url"
          class="link"
          >{{ breadcrumb.name }}</router-link
        >
        <span v-else>{{ breadcrumb.name }}</span>
      </span>
    </template>
  </div>
</template>

<script>
// import { mapActions, mapState } from 'vuex';

export default {
  name: 'BreadcrumbsC',
  components: {},
  computed: {
    breadcrumbs() {
      const breadcrumbs = []
      const fullPath = this.$route.fullPath
      const regex = /\/[^/]+$/
      let newPath = fullPath
      while (newPath !== '') {
        breadcrumbs.unshift({
          url: newPath,
          name: this.$router.resolve(newPath).meta.breadcrumb,
          access: this.$router.resolve(newPath).meta.access,
        })
        newPath = newPath.replace(regex, '')
      }

      return breadcrumbs
    },
    showBreadcrumbs() {
      let showBreadcrumbs = true
      if (['unpaidSingle'].includes(this.$route.name)) {
        showBreadcrumbs = false
      }
      return showBreadcrumbs
    },
  },
  methods: {},
  mounted() {},
}
</script>

<style lang="scss" scoped>
@use '@/scss/_variables.scss';

.breadcrumbs {
  margin-left: calc(var(--sp) * 1);
  margin-bottom: calc(var(--sp) * 0);
  @media only screen and (max-width: 1000px) {
    display: none;
  }
}

.breadcrumb {
  display: inline-block;
  padding-right: 1rem;
  font-size: 10px;
  a {
    color: var(--primary);
  }
}
.breadcrumb:after {
  content: '»';
  display: inline-block;
  padding-left: 1rem;
}
.breadcrumb:last-child a {
  text-decoration: none;
  color: var(--text-color);
}
.breadcrumb:last-child:after {
  content: '';
}
</style>
